import { render } from "./returnList.vue?vue&type=template&id=13f22e4b&scoped=true"
import script from "./returnList.vue?vue&type=script&lang=js"
export * from "./returnList.vue?vue&type=script&lang=js"

import "./returnList.vue?vue&type=style&index=0&id=13f22e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f22e4b"]])

export default __exports__